export default __webpack_public_path__ + "static/media/flag-icon-white.68238b83.svg";